import { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Navbar.css";

function Navbar({ seccionActiva, setSeccionActiva, onAbrirServicios }) {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [esAdmin, setEsAdmin] = useState(false);
  const [logueado, setLogueado] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef(null);
  const indicadorRef = useRef(null);

  const _itemsMenu = [
    { id: "inicio", label: "Inicio" },
    { id: "info-servicios", label: "Servicios", abreModal: true },
    { id: "galeria", label: "Galería" },
    { id: "sobre-cata", label: "Sobre Cata" },
    { id: "servicios", label: "Precios" },
  ];

  useEffect(() => {
    const manejarScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", manejarScroll, { passive: true });
    return () => window.removeEventListener("scroll", manejarScroll);
  }, []);

  useEffect(() => {
    const moverIndicador = () => {
      const contenedor = menuRef.current;
      const indicador = indicadorRef.current;
      if (!contenedor || !indicador) return;

      if (!window.matchMedia("(min-width: 1181px)").matches) {
        indicador.style.opacity = "0";
        return;
      }

      const activo = contenedor.querySelector(".navbar-item.activo");
      if (!activo) {
        indicador.style.opacity = "0";
        return;
      }

      const rectContenedor = contenedor.getBoundingClientRect();
      const rectActivo = activo.getBoundingClientRect();
      indicador.style.opacity = "1";
      indicador.style.width = `${rectActivo.width}px`;
      indicador.style.transform = `translateX(${rectActivo.left - rectContenedor.left}px)`;
    };

    moverIndicador();
    window.addEventListener("resize", moverIndicador);
    return () => window.removeEventListener("resize", moverIndicador);
  }, [seccionActiva]);

  useEffect(() => {
    const actualizarEstado = () => {
      const token = localStorage.getItem("token");
      const admin = localStorage.getItem("esAdmin");
      setLogueado(!!token);
      setEsAdmin(admin === "true");
    };
    actualizarEstado();
    window.addEventListener("storage", actualizarEstado);
    return () => window.removeEventListener("storage", actualizarEstado);
  }, []);

  const navegarASeccion = (id) => {
    setSeccionActiva(id);
    setMenuAbierto(false);
    navigate("/");
    setTimeout(() => {
      const elemento = document.getElementById(id);
      if (elemento) {
        elemento.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
  };

  const manejarClickItem = (item) => {
    if (item.abreModal) {
      setSeccionActiva(item.id);
      setMenuAbierto(false);
      navigate("/");
      if (onAbrirServicios) onAbrirServicios();
    } else {
      navegarASeccion(item.id);
    }
  };

  const irYCerrarMenu = (ruta) => {
    setMenuAbierto(false);
    navigate(ruta);
  };

  const cerrarSesion = () => {
    localStorage.clear();
    setLogueado(false);
    setEsAdmin(false);
    setMenuAbierto(false);
    navigate("/");
  };

  const irACuenta = () => {
    setMenuAbierto(false);
    if (!logueado) {
      navigate("/login");
    } else if (esAdmin) {
      navigate("/admin");
    } else {
      navigate("/mis-turnos");
    }
  };

  return (
    <nav className={"navbar " + (scrolled ? "navbar-scrolled" : "")}>
      <div className="navbar-contenedor">
        <div className="navbar-logo" onClick={() => navegarASeccion("inicio")}>
          <img src="/logo-glowroom.png" alt="Glowroom MVD" className="navbar-logo-img" />
          <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
            <span className="logo-principal">Glowroom</span>
            <span className="logo-secundario">MVD</span>
          </div>
        </div>

        <ul className={"navbar-menu " + (menuAbierto ? "menu-abierto" : "")} ref={menuRef}>
          <li className="navbar-indicador" ref={indicadorRef} aria-hidden="true"></li>
          {_itemsMenu.map((item) => (
            <li key={item.id}>
              <button
                className={"navbar-item " + (seccionActiva === item.id ? "activo" : "")}
                onClick={() => manejarClickItem(item)}
              >
                {item.label}
              </button>
            </li>
          ))}

          <li className="solo-mobile-li">
            <div className="navbar-menu-separador-mobile"></div>
          </li>

          {!logueado && (
            <li className="solo-mobile-li">
              <button className="navbar-item" onClick={() => irYCerrarMenu("/login")}>
                Iniciar sesión
              </button>
            </li>
          )}

          {logueado && esAdmin && (
            <li className="solo-mobile-li">
              <button className="navbar-item" onClick={() => irYCerrarMenu("/admin")}>
                Panel Admin
              </button>
            </li>
          )}

          {logueado && !esAdmin && (
            <li className="solo-mobile-li">
              <button className="navbar-item" onClick={() => irYCerrarMenu("/mis-turnos")}>
                Mis turnos
              </button>
            </li>
          )}

          {logueado && (
            <li className="solo-mobile-li">
              <button className="navbar-item" onClick={cerrarSesion}>
                Cerrar sesión
              </button>
            </li>
          )}
        </ul>

        <div className="navbar-acciones">
          {!logueado && (
            <Link to="/login" className="btn-login">
              Iniciar sesión
            </Link>
          )}

          {logueado && esAdmin && (
            <>
              <Link to="/admin" className="btn-admin">
                Panel Admin
              </Link>
              <button className="btn-login" onClick={cerrarSesion}>
                Cerrar sesión
              </button>
            </>
          )}

          {logueado && !esAdmin && (
            <>
              <Link to="/mis-turnos" className="btn-mis-turnos">
                Mis turnos
              </Link>
              <button className="btn-login" onClick={cerrarSesion}>
                Cerrar sesión
              </button>
            </>
          )}
        </div>

        <div className="navbar-acciones-mobile">
          <button className="navbar-cuenta" onClick={irACuenta} aria-label="Mi cuenta">
            <svg viewBox="0 0 24 24" className="navbar-cuenta-icono" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="8" r="3.4" />
              <path d="M5 20c1.2-4 4-6 7-6s5.8 2 7 6" />
            </svg>
          </button>

          <button
            className="navbar-hamburguesa"
            onClick={() => setMenuAbierto(!menuAbierto)}
            aria-label="Abrir menú"
          >
            <span className={"hamburguesa-linea " + (menuAbierto ? "abierta" : "")}></span>
            <span className={"hamburguesa-linea " + (menuAbierto ? "abierta" : "")}></span>
            <span className={"hamburguesa-linea " + (menuAbierto ? "abierta" : "")}></span>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;